import { VStack } from "@gluestack-ui/themed";
import { ProgressBar } from "@repo/core/components/layout/ProgressBar";
import { Text } from "@repo/core/components/core/Text";
import { PageScaffold } from "@repo/core/components/layout/Scaffolds/PageScaffold";
import { ScaffoldFooter } from "@repo/core/components/layout/Scaffolds/components/ScaffoldFooter";
import { PersonalReferenceFormController } from "./controller";
import { InputControlled } from "@repo/core/components/forms/InputControlled";
import { SelectControlled } from "@repo/core/components/forms/SelectControlled";

const PersonalReferenceForm = () => {
  const {
    control,
    handleOnSubmitForm,
    handleGoBack,
    handleClose,
    relationshipOptions,
    isLoadingRelationshipOptions
  } = PersonalReferenceFormController();
  return (
    <PageScaffold
      onBackPress={handleGoBack}
      showBackButtonOnWeb
      onPressRightIcon={handleClose}
      rightWebLabel="Fechar"
      title="Proposta de Crédito"
      footerContent={
        <ScaffoldFooter
          primaryText="Continuar"
          primaryAction="primary"
          primaryOnPress={handleOnSubmitForm}
        />
      }
    >
      <VStack w="$full" gap="$4" pb="$4">
        <ProgressBar progress={100} />

        <Text>Informe uma referência pessoal:</Text>

        <InputControlled
          control={control}
          isRequired
          label="Nome Completo"
          name="name"
          placeholder="Digite o nome da referência"
        />
        <SelectControlled
          control={control}
          isRequired
          label="Relacionamento"
          name="relationship"
          options={relationshipOptions}
          placeholder={
            isLoadingRelationshipOptions
              ? "Carregando relacionamentos..."
              : "Selecione o relacionamento"
          }
          isLoading={isLoadingRelationshipOptions}
        />
        <InputControlled
          control={control}
          isRequired
          keyboardType="number-pad"
          label="DDD e Celular"
          name="cellPhone"
          placeholder="Digite o DDD e número de celular"
          mask="cellphone"
        />
      </VStack>
    </PageScaffold>
  );
};
export default PersonalReferenceForm;
